import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildingModern = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.5 0h-8A1.51 1.51 0 0 0 11 1.2a.27.27 0 0 0 .05.21.25.25 0 0 0 .2.09h6.25a.75.75 0 0 1 0 1.5h-6.25a.25.25 0 0 0-.25.25v1a.25.25 0 0 0 .25.25h4.25a.75.75 0 0 1 0 1.5h-4.25a.25.25 0 0 0-.25.25v1a.25.25 0 0 0 .25.25h.25a3 3 0 0 1 3 3v13.22a.25.25 0 0 0 .25.28h1a.25.25 0 0 0 .25-.25V21a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2.75a.25.25 0 0 0 .25.25H21a1 1 0 0 0 1-1V1.5A1.5 1.5 0 0 0 20.5 0Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5 9h-8A1.5 1.5 0 0 0 2 10.5v.25a.25.25 0 0 0 .25.25H6.5a.75.75 0 0 1 0 1.5H2.25a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25H4.5a.75.75 0 0 1 0 1.5H2.25a.25.25 0 0 0-.25.25V23a1 1 0 0 0 1 1h.75a.25.25 0 0 0 .25-.25V21a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2.75a.25.25 0 0 0 .25.25h4.25a.5.5 0 0 0 .5-.5v-13A1.5 1.5 0 0 0 11.5 9Z",
		fill: "currentColor"
	})] })
});
export { SvgBuildingModern as ReactComponent };
